import { Mtds, SparkleIcon, useAuth } from 'prove-common'
import { BetaFeature, useBetaFeature } from '../../hooks/useBetaFeature'

type BetaFeatureToggleProps = {
  feature: BetaFeature
}

const BetaFeatureToggle = ({ feature }: BetaFeatureToggleProps) => {
  const betaFeature = useBetaFeature(feature.key)

  return (
    <Mtds.Card as={Mtds.Flex} data-align='center' data-justify='space-between'>
      <Mtds.Info data-variant='circle'>
        <SparkleIcon />
        <strong>{feature.title}</strong>
        <span>{feature.description}</span>
      </Mtds.Info>
      <Mtds.Field
        as='input'
        aria-label={`Slå ${feature.title} av eller på`}
        type='checkbox'
        role='switch'
        checked={betaFeature.enabled}
        disabled={!betaFeature.isSuccess}
        onChange={(event) => betaFeature.setEnabled(event.target.checked)}
      />
    </Mtds.Card>
  )
}

type BetaFeaturesSectionProps = {
  features: BetaFeature[]
}

export const BetaFeaturesSection = ({ features }: BetaFeaturesSectionProps) => {
  const { isAdmin } = useAuth()

  if (isAdmin !== true || features.length === 0) {
    return null
  }

  return (
    <Mtds.Group as={Mtds.Grid}>
      <Mtds.Prose>
        <Mtds.Heading as='h2' data-size='xs'>
          Beta-funksjoner
        </Mtds.Heading>
        <Mtds.Muted>
          Disse innstillingene er kun synlige for administratorer og gjelder
          bare din bruker.
        </Mtds.Muted>
      </Mtds.Prose>
      <Mtds.Grid>
        {features.map((feature) => (
          <BetaFeatureToggle key={feature.key} feature={feature} />
        ))}
      </Mtds.Grid>
    </Mtds.Group>
  )
}
